interface IUser {
  firstName: string;
  lastName: string;
  patronymic?: string | null;

  [x: string]: any;
}

export const getFullName = (user: IUser): string =>
  [user?.lastName, user?.firstName, user?.patronymic].filter(Boolean).join(' ');

export const getInitials = (user: {firstName?: string; lastName?: string; patronymic?: string | null}): string =>
  user?.patronymic
    ? `${user?.lastName || ''} ${user?.firstName?.charAt(0) || ''}.${user?.patronymic?.charAt(0) || ''}.`
    : `${user?.lastName || ''} ${user?.firstName?.charAt(0) || ''}.`;
